import React, { Component, Fragment } from 'react';
import ProfileMenu from '../ProfileMenu';
import swal from 'sweetalert';
import imageCompression from 'browser-image-compression';
import { dataDosen } from '../../../../dummy-data/dosen';

class DetailDosen extends Component {
    state = {
        foto: '',
        statusData: '',
        filedatas: '',
        data: [],
        nomer: '',
        label: '',
        kode_dosen: '',
        id_hidden: '',
        user: '',
        tgl_masuk: '',
        tgl_keluar: '',
        alamat: '',
        alamat_sekarang: '',
        no_hp: '',
        tempat: '',
        tanggal_lahir: '',
        jenis_kelamin: '',
        nidn: '',
        no_ktp: '',
        status_nikah: '',
        posisi1: '',
        posisi2: '',
        jabatan: '',
        jurusan_dosen: '',
        status_dosen: '',
        bpjs_kesehatan: '',
        masa_aktif_kesehatan: '',
        bpjs_ketenagakerjaan: '',
        masa_aktif_ketenagakerjaan: '',
        jenjang: '',
        gfoto: '',
        password: ''
    };

    ck = (e) => {
        e.preventDefault();
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    // foto profile konfig
    fotoConfig = async (event) => {
        this.setState({ gfoto: 1 });
        let fotoDosen = event.target.files[0];
        let fileFoto = document.getElementById('upload-photo');

        const options = {
            maxSizeMB: 0.25,
            maxWidthOrHeight: 1280,
            useWebWorker: true
        };

        if (/(\.jpg|\.jpeg|\.png)$/i.test(fileFoto.files[0].name) === false) {
            document.getElementById('upload-photo').value = '';
            document.getElementById('foto').src = '';
            swal({
                icon: 'info',
                title: 'Form Gambar',
                text: 'File harus berformat gambar'
            });
            return false;
        } else {
            const compressedFile = await imageCompression(fotoDosen, options);
            this.setState({ foto: compressedFile });
            if (compressedFile != null || compressedFile != '') {
                document.getElementById('foto').src = URL.createObjectURL(compressedFile);
            }
        }
    };

    InputChange = (event) => {
        event.preventDefault();
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    componentDidMount = () => {
        let id = parseInt(this.props.match.params.dosenid);
        const dosen = dataDosen.find(d => d.dosen_id === id);

        if (dosen) {
            this.setState({
                data: dosen,
                nomer: dosen.dosen_id,
                label: dosen.nama,
                kode_dosen: dosen.nidn,
                id_hidden: dosen.status === 'Aktif' ? 1 : 0,
                user: dosen.nidn,
                tgl_masuk: '2015-08-01',
                tgl_keluar: '',
                alamat: dosen.alamat || 'Jakarta',
                alamat_sekarang: dosen.alamat || 'Jakarta',
                no_hp: dosen.no_hp || '08123456789',
                tempat: 'Jakarta',
                tanggal_lahir: '1980-01-15',
                jenis_kelamin: dosen.jenis_kelamin === 'Perempuan' ? 1 : 0,
                nidn: dosen.nidn,
                no_ktp: '3171234567890001',
                status_nikah: 0,
                posisi1: 'Dosen FTD',
                posisi2: 'Prodi',
                jabatan: dosen.jabatan || 'Lektor',
                jurusan_dosen: dosen.prodi || 'Teknik Informatika',
                status_dosen: dosen.status,
                bpjs_kesehatan: '0001234567890',
                masa_aktif_kesehatan: '2025-12-31',
                bpjs_ketenagakerjaan: '0009876543210',
                masa_aktif_ketenagakerjaan: '2025-12-31',
                jenjang: dosen.pendidikan || 'Strata 2',
                foto: '/no-image.jpg',
                password: '********'
            });
        }
    };

    SubmitEdit = () => {
        let btn = document.getElementById('btnSub');
        btn.disabled = true;
        btn.innerHTML = 'wait&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i>';

        setTimeout(() => {
            swal({
                icon: "success",
                title: "Demo Mode",
                text: "Data berhasil disimpan (simulasi)",
                timer: 2000,
                buttons: false,
            });
            btn.disabled = false;
            btn.innerHTML = 'simpan data';
        }, 1000);
    };

    render() {
        const jk = (val) => {
            if (val == 0) return 'Laki Laki';
            else if (val == 1) return 'Perempuan';
        }

        const stsnikah = (val) => {
            if (val == 0) return 'Menikah';
            else if (val == 1) return 'Belum Menikah';
            else if (val == 2) return 'Duda / Janda';
        }

        return (
            <Fragment>
                <div id="smoothMain">
                    <div className="row">
                        <div className="col-xl-3">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="outer">
                                        <img
                                            src={this.state.foto}
                                            className="fotoDetail"
                                            id="foto"
                                        />
                                        <div className="inner" title="ganti photo">
                                            <input
                                                className="inputfile"
                                                id="upload-photo"
                                                type="file"
                                                accept="image/*"
                                                onChange={this.fotoConfig}
                                                name="foto"
                                            />
                                            <label className="ti-camera" />
                                        </div>
                                    </div>
                                </div>
                                <ProfileMenu />
                            </div>
                        </div>
                        <div className="col-xl-9">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card card-custom">
                                        <div className="card-body">
                                            {/* tab biodata  */}
                                            <div className="row tabsCon" id="tab1box" style={{ padding: '5%' }}>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Nama Lengkap :</label>
                                                        <input
                                                            type="text"
                                                            name="label"
                                                            defaultValue={this.state.label}
                                                            onChange={this.ck}
                                                            className="form-control form-custom"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Nomor Pegawai :</label>
                                                        <input
                                                            type="text"
                                                            name="user"
                                                            defaultValue={this.state.user}
                                                            onChange={this.ck}
                                                            className="form-control form-custom"
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Nomor KTP :</label>
                                                        <input
                                                            type="text"
                                                            name="no_ktp"
                                                            defaultValue={this.state.no_ktp}
                                                            onChange={this.ck}
                                                            className="form-control form-custom"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>NIDN :</label>
                                                        <input
                                                            type="text"
                                                            name="nidn"
                                                            defaultValue={this.state.nidn}
                                                            onChange={this.ck}
                                                            className="form-control form-custom"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Kode Dosen :</label>
                                                        <input
                                                            type="text"
                                                            name="kode_dosen"
                                                            defaultValue={this.state.kode_dosen}
                                                            onChange={this.ck}
                                                            className="form-control form-custom"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Tempat Lahir :</label>
                                                        <input
                                                            type="text"
                                                            name="tempat"
                                                            defaultValue={this.state.tempat}
                                                            onChange={this.ck}
                                                            className="form-control form-custom"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Tanggal Lahir :</label>
                                                        <input
                                                            type="date"
                                                            name="tanggal_lahir"
                                                            defaultValue={this.state.tanggal_lahir}
                                                            onChange={this.ck}
                                                            className="form-control form-custom"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Jenis Kelamin :</label>
                                                        <select
                                                            name="jenis_kelamin"
                                                            className="form-control form-custom"
                                                            onChange={this.ck}
                                                        >
                                                            <option value={this.state.jenis_kelamin}>{jk(this.state.jenis_kelamin)}</option>
                                                            <option value="0">Laki Laki</option>
                                                            <option value="1">Perempuan</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Pendidikan Terakhir :</label>
                                                        <select
                                                            name="jenjang"
                                                            className="form-control form-custom"
                                                            onChange={this.ck}
                                                        >
                                                            <option value={this.state.jenjang}>{this.state.jenjang}</option>
                                                            <option value="Strata 1">Strata 1</option>
                                                            <option value="Strata 2">Strata 2</option>
                                                            <option value="Strata 3">Strata 3</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Status Nikah :</label>
                                                        <select
                                                            name="status_nikah"
                                                            className="form-control form-custom"
                                                            onChange={this.ck}
                                                        >
                                                            <option value={this.state.status_nikah}>{stsnikah(this.state.status_nikah)}</option>
                                                            <option value="0">Menikah</option>
                                                            <option value="1">Belum Menikah</option>
                                                            <option value="2">Duda / Janda</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Alamat KTP :</label>
                                                        <textarea
                                                            name="alamat"
                                                            cols="30"
                                                            rows="3"
                                                            onChange={this.ck}
                                                            className="form-control form-custom"
                                                            defaultValue={this.state.alamat}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Alamat Sekarang :</label>
                                                        <textarea
                                                            name="alamat_sekarang"
                                                            cols="30"
                                                            rows="3"
                                                            onChange={this.ck}
                                                            className="form-control form-custom"
                                                            defaultValue={this.state.alamat_sekarang}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* button  */}
                                            <div className="container mb-4" style={{ padding: '0% 5%' }}>
                                                <p align="right">
                                                    <button
                                                        id="btnSub"
                                                        type="button"
                                                        className="btn btn-primary ml-4"
                                                        onClick={this.SubmitEdit}>
                                                        simpan data
                                                    </button>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default DetailDosen;
